module.exports = __webpack_public_path__ + "img/fr.b1156355.svg";